import React, { useState } from 'react';
import { Table, Modal, Space, Tooltip } from 'antd';
import { FileProtectOutlined } from '@ant-design/icons';

const ViewFileModal = ({isFileModalVisible, fileData, closeFileModal}) => {

  const fileColumns = [] //fileData.map()

  return 
      {/* 文件 Modal */}
      <Modal
        title="文件列表"
        show={isFileModalVisible}
        onCancel={closeFileModal}
        footer={null}
      >
        <Table
          columns={fileColumns}
          dataSource={fileData}
          pagination={false}
          rowKey="filename"
        />
      </Modal>
};

export default ViewFileModal;
